import React, { useContext, useEffect, useState } from 'react'
import css from './Projects.module.css'
import { projectContent } from './Content'
import {BsArrowUpRight} from 'react-icons/bs'
import Modal from './Modal'
import { UserContext } from '../UseContext'
import {motion} from 'framer-motion'
import { draw, fadeIn, slideIn, staggerChildren, textVariant, textVariant2, zoomIn } from "../utils/motion";

const Projects = () => {

const{modal,setModal}=useContext(UserContext)

const [content,setContent]=useState([])


useEffect(() => {
setContent(projectContent)
  }, []);
// const[modal,setModal]=useState(false)
const[forIndex,setForIndex]=useState(null)

const openpro=(index)=>{
    // setModal(false)

    setModal(true)
    setForIndex(index)
    console.log(index)
    console.log(modal)
    console.log(forIndex)

}
return (
<>
<a className="position_atag" id='projects'></a>

<motion.div  variants={staggerChildren}
    initial="hidden"
    whileInView="show"
    viewport={{ once: false, amount: 0.25 }} className={css.projectbg} >
    <p>My Projects</p>
    <motion.div variants={textVariant(.4)} className={css.projectlist}>
        {content.map((get,index)=>{
            // console.log(get)
            return(
<>
<div  className={css.cardbg} 
onClick={()=>openpro(index)}

>

    <div className={`${css.imgdiv} ${get.forcss}`}>
<div className={css.circle}></div>

        <img src={get.icon}/>
    </div>
    <h6
    
    ><BsArrowUpRight/>Open</h6>

    <p>( {get.project} )</p>
</div>
{
    modal && forIndex===index?
<Modal bannerone={get.bannerone} bannertwo={get.bannertwo} bannerthree={get.bannerthree}
bannerfour={get.bannerfour}
live={get.live} frontendlink={get.frontendlink} backendlink={get.backendlink} 
workedon={get.workedon} about={get.about}
 title={get.title}/>
:""
}
</>
            )
        })}

    </motion.div>
</motion.div>
{/* <Modal/> */}

</> 
 )
}

export default Projects